export const GET_ADMIN_USERS_LIST_REQUEST =
  '@admin/users-list/GET_ADMIN_USERS_LIST_REQUEST';
export const GET_ADMIN_USERS_LIST_SUCCESS =
  '@admin/users-list/GET_ADMIN_USERS_LIST_SUCCESS';
export const GET_ADMIN_USERS_LIST_FAILURE =
  '@admin/users-list/GET_ADMIN_USERS_LIST_FAILURE';

export const SET_ADMIN_USERS_LIST_PAGE =
  '@admin/users-list/SET_ADMIN_USERS_LIST_PAGE';
